import React from 'react'
import Formation from '../../Component/Pedagogie/Formation'
import Classe from '../../Component/Pedagogie/Classe'
import Eleve from '../../Component/Pedagogie/Eleve'
import ClasseEleve from '../../Component/Pedagogie/ClasseEleve'
import Grid from '@material-ui/core/Grid/Grid'
import Utils from 'EurestoFonction/Utils'
import Bus from 'EurestoClass/Bus'


export default (class extends React.Component {

  state = {
    UserTabSelected: 0,
    busGUID: Utils.uuidv4()
  }

  crmConfiguration = [
    {
      component: <Formation/>
    },
    {
      component: <Classe/>
    },
    {
      component: <Eleve/>
    },
    {
      component: <ClasseEleve/>
    },
  ]


  componentWillUnmount () {
    Bus.$off('donnees_annexes_pedagogie',this.state.busGUID)
  }

  componentDidMount () {
    Bus.$on('donnees_annexes_pedagogie', id=> {
      this.setState({UserTabSelected: id})
    }, this.state.busGUID)
  }

  render () {
    return <Grid container style={{margin: 0, padding: 0, width: '100%'}} spacing={0}>
      <Grid item xs={12} style={{margin: 0, padding: 0}}>
        {
          this.crmConfiguration[this.state.UserTabSelected].component
        }
      </Grid>
    </Grid>
  }
})



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Page/Pedagogie/index.js